"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultOtherTransactionsState = exports.defaultTransactionsState = void 0;
var TransactionRecord_init_1 = require("@/pages/estate/states/TransactionRecord.init");
var TransactionsTranslate_init_1 = require("@/pages/common/states/TransactionsTranslate.init");
exports.defaultTransactionsState = {
    t: TransactionsTranslate_init_1.defaultTransactionsTranslate,
    transactions: TransactionRecord_init_1.defaultTransactionRecords,
    transactionTotalPage: 1,
    transactionCurrentPage: 1,
    buildingId: 2,
    districtId: 0,
    estateId: 0,
    phaseId: 0,
    propertyTransactionId: 0,
};
exports.defaultOtherTransactionsState = {
    t: TransactionsTranslate_init_1.defaultTransactionsTranslate,
    transactions: TransactionRecord_init_1.defaultTransactionRecords.slice(0, 2),
    transactionTotalPage: 1,
    transactionCurrentPage: 1,
    buildingId: 0,
    districtId: 0,
    estateId: 0,
    phaseId: 0,
    propertyTransactionId: 32145,
};
